"use client";

import { useStores } from "../../../../stores/useStores";
import styles from "../styles/SchoolFeedPageWrapperHeader.module.scss";
import FontAwesome from "../../../utilities/FontAwesome";
import { navigationContent } from "../../navigation/MobileNav/utils";
import { RecursiveRcMenu } from "../../navigation/MobileNav/RecursiveRCMenu";
import { observer } from "mobx-react";
import { useComponentVisible } from "../../../../hooks/useComponentVisible";
import classNames from "classnames";
import ModalBackdrop from "../../../modals/_ModalBackdrop";
import zIndex from "../../../../styles/_zIndex.module.scss";

const SideBarMenu = (props: {
  setIsComponentVisible: (visible: boolean) => void;
  className?: string;
  menuClassName?: string;
}) => {
  const { organizationStore } = useStores();

  const content = navigationContent(organizationStore);

  return (
    <div className={props.className}>
      <div>
        <div className={styles.closeButton}>
          <button
            aria-label={"Close Navigation"}
            onClick={() => props.setIsComponentVisible(false)}
          >
            <FontAwesome name={"fa-times"} prefix={"fas"} />
          </button>
        </div>
        <RecursiveRcMenu
          content={content}
          isSubMenu={false}
          mode={"inline"}
          className={props.menuClassName}
          selectable={false}
          motion={{
            motionName: "rc-menu-collapse",
            motionEnter: true,
            motionLeave: true,
            onEnterStart: () => ({ height: 0 }),
            onEnterActive: (el) => ({
              height: `calc(${el.children.length * 2}rem + ${el.children.length * 16}px)`,
            }),
            onLeaveStart: (el) => ({
              height: `calc(${el.children.length * 2}rem + ${el.children.length * 16}px)`,
            }),
            onLeaveActive: () => ({ height: 0 }),
          }}
        />
      </div>
    </div>
  );
};

export const SchoolFeedPageWrapperHeaderClientSideBar = observer(() => {
  const { organizationStore } = useStores();

  const { setIsComponentVisible, isComponentVisible } =
    useComponentVisible(false);

  const menuContainerClassName = classNames({
    [styles.sidebarMenu]: true,
    [styles.sidebarMenuOpen]: isComponentVisible,
  });

  return (
    <>
      <SideBarMenu
        className={menuContainerClassName}
        setIsComponentVisible={setIsComponentVisible}
      />
      {organizationStore.navigation.length > 0 && (
        <div className={styles.menuHamburgerButton}>
          <button
            aria-label={"Open Navigation"}
            onClick={() => setIsComponentVisible(true)}
          >
            <FontAwesome name={"fa-bars"} size={"2x"} prefix={"fas"} />
          </button>
        </div>
      )}
      {isComponentVisible && (
        <div style={{ position: "absolute" }}>
          <ModalBackdrop
            active={true}
            onMouseDown={() => setIsComponentVisible(false)}
            zIndex={parseInt(zIndex["z-index-cleverfeed-sidebar"]) - 1}
          />
        </div>
      )}
    </>
  );
});
